import { AmountInputCard } from './components/AmountInput';
import { Complex } from './components/Complex';
import { ItemPrice } from './components/ItemPrice';
import { Text } from './components/Text';
import type { SelectionCardProps } from './SelectionCard.types';

export const SelectionCard: React.FC<SelectionCardProps> = (props) => {
	const { type } = props;

	switch (type) {
		case 'amountInput':
			return <AmountInputCard {...props} />;
		case 'complex':
			return <Complex {...props} />;
		case 'text':
			return <Text {...props} />;
		default:
			return <ItemPrice {...props} />;
	}
};
